module.exports = __webpack_public_path__ + "static/media/man (1).a76b0e5a.png";